import type { ReactNode } from "react";

import { Soon } from "../../ui/Soon";

interface SoonControlProps {
  className: string | undefined;
  children: ReactNode;
  /** A whole card rather than a button: it spans its cell. */
  block?: boolean;
  /** The control's name where its text is not (a card). */
  label?: string;
}

/**
 * A control of the redesign whose page is not built yet (spec ui-perf/pro-studio-redesign,
 * decision 10): the prototype's look, `Soon`'s "Coming soon", no handler. The PR that builds the
 * page makes it a link.
 */
export function SoonControl({ className, children, block = false, label }: SoonControlProps) {
  return (
    <Soon block={block}>
      {(props) => (
        <button type="button" className={className} aria-label={label} {...props}>
          {children}
        </button>
      )}
    </Soon>
  );
}
